import { MetaFunction } from '@remix-run/node'

import { ContactSuccessPage, TopFooter, TopHeader } from '~/features'

export const meta: MetaFunction = ({ matches }) => {
  const parentMeta = matches
    .flatMap((match) => match.meta ?? [])
    .filter((meta) => !('title' in meta))
  return [
    ...parentMeta,
    {
      title:
        'お問い合わせに成功しました。 | シェアオフィス コワーキングスペース検索サイト',
    },
  ]
}

export default function Index() {
  return (
    <div className="flex min-h-screen flex-col">
      <TopHeader />
      <div className="flex-grow pt-14">
        <ContactSuccessPage />
      </div>
      <TopFooter />
    </div>
  )
}
